import { createContext, useContext, useMemo, type ReactNode } from 'react'
import { getPublicSiteBranding, type PublicSiteBranding } from '../content/publicSiteBranding'
import { getSiteTerminology, type SiteTerminology } from '../content/siteTerminology'
import { getPublicSiteId, type PublicSiteId } from '../utils/publicSite'
import { getRoles, type Roles } from '../utils/roles'

const PublicSiteContext = createContext<PublicSiteId>('default')

export function PublicSiteProvider({ children }: { children: ReactNode }) {
  const siteId = useMemo(() => getPublicSiteId(), [])

  return (
    <PublicSiteContext.Provider value={siteId}>{children}</PublicSiteContext.Provider>
  )
}

export function usePublicSiteId(): PublicSiteId {
  return useContext(PublicSiteContext)
}

export function usePublicSiteBranding(): PublicSiteBranding {
  const siteId = usePublicSiteId()
  return useMemo(() => getPublicSiteBranding(siteId), [siteId])
}

export function useSiteTerminology(): SiteTerminology {
  const siteId = usePublicSiteId()
  return useMemo(() => getSiteTerminology(siteId), [siteId])
}

export function useRoles(): Roles {
  const siteId = usePublicSiteId()
  return useMemo(() => getRoles(siteId), [siteId])
}
